const fields = {
  id: null,
  name: {
    label: 'Application Number'
  },
  applicant: null,
  alternate_contact: null,
  listing: null,
  'listing.name': {
    label: 'Listing Name'
  },
  'listing.id': null,
  status: null,
  'listing.reserved_community_type': null,
  total_household_size: null,
  application_submission_type: null,
  application_submitted_date: null,
  'createdby.name': {
    label: 'Created By'
  },
  annual_income: null,
  monthly_income: null,
  is_first_time_homebuyer: null,
  'listing.is_lottery_complete': null,
  housing_voucher_or_subsidy: null,
  referral_source: null,
  application_language: null,
  lottery_number_manual: null,
  lottery_number: null,
  total_monthly_rent: null,
  general_lottery: null,
  general_lottery_rank: null,
  answered_community_screening: null,
  has_completed_homebuyer_education: null,
  has_loan_preapproval: null,
  has_military_service: null,
  has_developmental_disability: {
    label: 'Has Developmental Disability'
  },
  has_ada_priorities_selected: null,
  terms_acknowledged: null,
  'applicant.id': null,
  'applicant.first_name': null,
  'applicant.last_name': null,
  'applicant.middle_name': null,
  'applicant.name': null,
  'applicant.date_of_birth': null,
  'applicant.phone_type': null,
  'applicant.phone': null,
  'applicant.second_phone_type': null,
  'applicant.second_phone': null,
  'applicant.email': null,
  'applicant.primary_language': null,
  'applicant.residence_address': null,
  'applicant.street': null,
  'applicant.city': null,
  'applicant.state': null,
  'applicant.zip_code': null,
  'applicant.mailing_address': null,
  'applicant.mailing_street': null,
  'applicant.mailing_city': null,
  'applicant.mailing_state': null,
  'applicant.mailing_zip_code': null,
  'applicant.marital_status': null,
  'alternate_contact.id': null,
  'alternate_contact.first_name': null,
  'alternate_contact.middle_name': null,
  'alternate_contact.last_name': null,
  'alternate_contact.phone_type': null,
  'alternate_contact.phone': null,
  'alternate_contact.email': null,
  'alternate_contact.agency_name': null,
  'alternate_contact.alternate_contact_type': {
    label: 'Relationship'
  },
  'alternate_contact.alternate_contact_type_other': {
    label: 'Relationship - Other'
  },
  number_of_dependents: null,
  number_of_seniors: null,
  number_of_minors: null,
  lending_institution: null,
  name_of_lender: null
}

export default fields
